import React from 'react';

interface StepBasicInfoProps {
    formData: {
        name: string;
        email: string;
        phone: string;
        cpf: string;
    };
    updateFormData: (data: Partial<{ name: string; email: string; phone: string; cpf: string }>) => void;
    onNext: () => void;
    error: string | null;
}

const StepBasicInfo: React.FC<StepBasicInfoProps> = ({ formData, updateFormData, onNext, error }) => {
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onNext();
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="text-center mb-8">
                <p className="text-sm text-primary font-medium mb-2">Informações adicionais</p>
                <h2 className="text-2xl font-bold text-gray-900">Seus dados</h2>
                <p className="text-gray-500 text-sm mt-2">Informe seus dados para criar sua conta</p>
            </div>

            {error && (
                <div className="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                    {error}
                </div>
            )}

            <div className="space-y-4">
                <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                        Nome completo
                    </label>
                    <input
                        id="name"
                        type="text"
                        value={formData.name}
                        onChange={(e) => updateFormData({ name: e.target.value })}
                        className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                        placeholder="Seu nome completo"
                    />
                </div>

                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                        Email
                    </label>
                    <input
                        id="email"
                        type="email"
                        value={formData.email}
                        onChange={(e) => updateFormData({ email: e.target.value })}
                        className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                        placeholder="seu@email.com"
                    />
                </div>

                <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                        WhatsApp
                    </label>
                    <input
                        id="phone"
                        type="tel"
                        value={formData.phone}
                        onChange={(e) => updateFormData({ phone: e.target.value })}
                        className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                        placeholder="(00) 00000-0000"
                    />
                </div>

                <div>
                    <label htmlFor="cpf" className="block text-sm font-medium text-gray-700 mb-1">
                        CPF / CNPJ
                    </label>
                    <input
                        id="cpf"
                        type="text"
                        value={formData.cpf}
                        onChange={(e) => updateFormData({ cpf: e.target.value })}
                        className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all"
                        placeholder="CPF ou CNPJ"
                    />
                </div>
            </div>

            <button
                type="submit"
                className="w-full py-3 px-4 bg-primary hover:bg-primary-dark text-white font-semibold rounded-xl transition-all shadow-sm"
            >
                Continuar
            </button>
        </form>
    );
};

export default StepBasicInfo;
